import apiPaths from '../api-paths';

export default {
  getKpirSummary({ filters }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/kpir/summary`, { params: { filters } });
  },
  getRyczaltSummary({ filters }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/ryczalt/summary`, { params: { filters } });
  },
  getKhSummary({ filters }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/kh/summary`, { params: { filters } });
  },
  getVatSaleSummary({ filters }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/vat-sale/summary`, { params: { filters } });
  },
  getVatPurchaseSummary({ filters }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/evidences/vat-purchase/summary`, { params: { filters } });
  },
};
